const exported = {
    date: {
        short: {
            day: "2-digit",
            month: "2-digit"
        }
    }
};

export default exported;

export const { date } = exported;
